<template>
  <div class="container mx-auto">
    <h2 class="font-semibold text-lg mx-auto">Vytvoriť nového distribútora / predajcu</h2>
    <form @submit.prevent="onSubmit" class="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-gray-200 mx-2 rounded-md">
      <div class="md:col-span-2">
        <label class="block text-left" for="storeName">Názov predajne (povinné)</label>
        <input
          class="block px-4 py-3 w-full text-left rounded-md"
          type="text"
          name="storeName"
          v-model="form.store_name"
          required
          placeholder="Názov predajne alebo predajcu"
        />
      </div>
      <div>
        <label class="block text-left" for="storeAddress">Adresa predajne</label>
        <input
          class="block px-4 py-3 w-full text-left rounded-md"
          type="text"
          name="storeAddress"
          v-model="form.store_address"
          placeholder="Adresa predajne - ulica a číslo domu"
        />
      </div>
      <div>
        <label class="block text-left" for="billingAddress">Fakturačná adresa</label>
        <input
          class="block px-4 py-3 w-full text-left rounded-md"
          type="text"
          name="billingAddress"
          v-model="form.billing_address"
          placeholder="Fakturačná adresa - ulica a číslo domu"
        />
      </div>
      <div>
        <label class="block text-left" for="city">Mesto</label>
        <input class="block px-4 py-3 w-full text-left rounded-md" type="text" name="city" v-model="form.city" placeholder="Mesto v ktorom sa predajna / predajca nachádza"/>
      </div>
      <div>
        <label class="block text-left" for="email">Krajina (povinné)</label>
        <select class="block px-4 py-3 w-full text-left rounded-md" name="country" v-model="form.country" required>
          <option value="">Select Country</option>
          <option value="sk">Slovensko</option>
          <option value="cz">Česko</option>
          <option value="mr">Morava</option>
        </select>
      </div>
      <div>
        <label class="block text-left" for="ownerName">Meno / Vlastnik</label>
        <input
          class="block px-4 py-3 w-full text-left rounded-md"
          type="text"
          name="ownerName"
          v-model="form.owner_name"
          placeholder="Meno vlastníka predajne"
        />
      </div>
      <div>
        <label class="block text-left" for="email">Email</label>
        <input
          class="block px-4 py-3 w-full text-left rounded-md"
          type="email"
          name="email"
          v-model="form.owner_email"
          placeholder="Emailový kontakt"
        />
      </div>
      <div>
        <label class="block text-left" for="phone">Telefón</label>
        <input class="block px-4 py-3 w-full text-left rounded-md" type="text" name="phone" v-model="form.phone" placeholder="Telefónny kontakt" />
      </div>

      <div class="self-end ml-auto">
        <button class="bg-green-400 hover:bg-green-500 rounded-md text-white font-semibold px-4 py-3" type="submit">
          Vytvoriť predajcu
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { createDistributor } from "../firebase";
import { reactive } from "vue";

export default {
  setup() {
    const form = reactive({
      store_name: "",
      store_address: "",
      owner_name: "",
      owner_email: "",
      phone: "",
      city: "",
      country: "",
      billing_address: "",
    });

    const onSubmit = async () => {
      await createDistributor({ ...form });

      // Clear the form
      form.store_name = "";
      form.store_address = "";
      form.owner_name = "";
      form.owner_email = "";
      form.phone = "";
      form.city = "";
      form.country = "";
      form.billing_address = "";
    };

    // START OF MASS DATA ARRAY
    // const batch = [
    //   {
    //     city: "Brno",
    //     country: "cz",
    //     store_name: "BUTIK INLET",
    //     store_address: "Behounská 17, 641 00  Brno",
    //     owner_name: "Pavlovičová Iveta",
    //     owner_email: "i.pavlovicova@seznam.cz",
    //     phone: "724244300",
    //     billing_address: "Na Padělkách 702/5, 641 00  Brno",
    //   },
    //   {
    //     city: "Brno",
    //     country: "cz",
    //     store_name: "Móda NEO Jeans",
    //     store_address: "OD OLYMPIA, U Dálnice 777, 664 42  Modřice",
    //     owner_name: "",
    //     owner_email: "modaneojeans@gmail.com",
    //     phone: "",
    //     billing_address: "Panská 389/16, 602 00  Brno",
    //   },
    //   {
    //     city: "Brno",
    //     country: "cz",
    //     store_name: "JANINA MÓDA",
    //     store_address: "Panská 6, 602 00  Brno",
    //     owner_name: "Javorčeková Jana",
    //     owner_email: "",
    //     phone: "731019622",
    //     billing_address: "Podbělova 7, 628 00  Brno",
    //   },
    //   {
    //     city: "Staré Město",
    //     country: "cz",
    //     store_name: "ALBERT",
    //     store_address: "Východní 1352, 686 03 Staré Město",
    //     owner_name: "Vaďurová Jitka",
    //     owner_email: "jitusjh@seznam.cz",
    //     phone: "777197163",
    //     billing_address: "Jezuitská 17, 686 03  Staré Město",
    //   },
    //   {
    //     city: "Blansko",
    //     country: "cz",
    //     store_name: "Obchod",
    //     store_address: "Náměstí Slobody 4, 678 01  Blansko",
    //     owner_name: "Zouharová Dagmar",
    //     owner_email: "dagmar.zouharova@seznam.cz",
    //     phone: "777196808",
    //     billing_address: "Horní Palava 2354/16, 678 01  Blansko",
    //   },
    //   {
    //     city: "Polička",
    //     country: "cz",
    //     store_name: "HIT",
    //     store_address: "Riegrová 23, 572 01 Polička",
    //     owner_name: "Tošovská Vlasta",
    //     owner_email: "",
    //     phone: "603262109",
    //     billing_address: "Riegrova 23, 572 01  Polička",
    //   },
    //   {
    //     city: "Litomyšl",
    //     country: "cz",
    //     store_name: "",
    //     store_address: "Smetanovo nám. 103, 570 01  Litomyšl",
    //     owner_name: "Nonnová Alena",
    //     owner_email: "",
    //     phone: "603582180",
    //     billing_address: "Smetanovo nám. 103, 570 01  Litomyšl",
    //   },
    //   {
    //     city: "Lanškroun",
    //     country: "cz",
    //     store_name: "Boutique SABRINA",
    //     store_address: "Lorencová Alej  1114, 563 01 Lanškroun",
    //     owner_name: "Němcová Alena",
    //     owner_email: "al@inlane.cz",
    //     phone: "606502445",
    //     billing_address: "B. Martinu 954, 563 01 Lanškroun",
    //   },
    //   {
    //     city: "Žamberk",
    //     country: "cz",
    //     store_name: "LINIE - R",
    //     store_address: "Nádražní 688, 564 01  Žamberk",
    //     owner_name: "Šmídlová Ružena",
    //     owner_email: "linie@orlicko.cz",
    //     phone: "602302296",
    //     billing_address: "Nádražní 688, 564 01  Žamberk",
    //   },
    //   {
    //     city: "Rychnov nad Kněžnou",
    //     country: "cz",
    //     store_name: "REDA",
    //     store_address: "Palackého 109, 516 01 Rychnov nad Kněžnou",
    //     owner_name: "Repová Gabriela",
    //     owner_email: "ivetarepova@seznam.cz",
    //     phone: "605256367",
    //     billing_address: "Palackého 109, 516 01 Rychnov nad Kněžnou",
    //   },
    //   {
    //     city: "Police n/M.",
    //     country: "cz",
    //     store_name: "BUTIQUE",
    //     store_address: "T.G.M.  81, 549 54  Police nad Metuji",
    //     owner_name: "Břeská Iva",
    //     owner_email: "breskaiva@gmail.com",
    //     phone: "725003605",
    //     billing_address: "Bělská 406, 549 54 police nad Metuji",
    //   },
    //   {
    //     city: "Trutnov",
    //     country: "cz",
    //     store_name: "MODEX",
    //     store_address: "Horská 6, 541 01  Trutnov",
    //     owner_name: "Kučerová Blanka",
    //     owner_email: "b.modex@email.cz",
    //     phone: "603483184",
    //     billing_address: "Smetanova 811, 541 01  Trutnov",
    //   },
    //   {
    //     city: "Hradec Králové",
    //     country: "cz",
    //     store_name: "MARADO",
    //     store_address: "Švehlova 252, 500 02 Hradec Králové",
    //     owner_name: "Radoňová",
    //     owner_email: "",
    //     phone: "603842111",
    //     billing_address: "Švehlová 252, 500 02 Hradec Králové",
    //   },
    //   {
    //     city: "Pardubice",
    //     country: "cz",
    //     store_name: "ELBA",
    //     store_address: "Palackého třída 1930, 530 02  Pardubice",
    //     owner_name: "Ing. Stanková Elena",
    //     owner_email: "elbarevolution@volny.cz",
    //     phone: "724740657",
    //     billing_address: "Bartoňova 1079, 530 12  Pardubice",
    //   },
    //   {
    //     city: "Chrudim",
    //     country: "cz",
    //     store_name: "",
    //     store_address: "",
    //     owner_name: "Nekvindová Miluše",
    //     owner_email: "",
    //     phone: "777290560",
    //     billing_address: "Topolská 746, 537 05 Chrudim",
    //   },
    //   {
    //     city: "Jičín",
    //     country: "cz",
    //     store_name: "DANTE  FASHION",
    //     store_address: "",
    //     owner_name: "p. Macková",
    //     owner_email: "dante@dante-fashion.cz",
    //     phone: "731170045",
    //     billing_address: "Nábř. Kpt. Jaroše 49, 506 01  Jičín",
    //   },
    //   {
    //     city: "Poděbrady",
    //     country: "cz",
    //     store_name: "",
    //     store_address: "Palackého 102, 290 01 Podebrady",
    //     owner_name: "Bánska Blanka",
    //     owner_email: "b.banska@seznam.cz",
    //     phone: "731417350",
    //     billing_address: "Nová  114, 290 01  Poděbrady",
    //   },
    //   {
    //     city: "Žďár nad Sádzavou",
    //     country: "cz",
    //     store_name: "MN Mode",
    //     store_address: "",
    //     owner_name: "Neubauerová",
    //     owner_email: "ludmila.neubauerova@epp.cz",
    //     phone: "731135526",
    //     billing_address: "Velká Losenice 353, 592 11 Velká Losenice",
    //   },
    //   {
    //     city: "Holešov",
    //     country: "cz",
    //     store_name: "",
    //     store_address: "Palackého 523, 769 01  Holešov",
    //     owner_name: "Russková Jana",
    //     owner_email: "JanaRusskova@seznam.cz",
    //     phone: "723489544",
    //     billing_address: "Sadová 1536, 769 01  Holešov",
    //   },
    //   {
    //     city: "Záryby",
    //     country: "cz",
    //     store_name: "",
    //     store_address: "",
    //     owner_name: "Znamenáčková Zuzana",
    //     owner_email: "",
    //     phone: "608020745",
    //     billing_address: "Záryby 15, 277 13 Záryby",
    //   },
    //   {
    //     city: "Tábor",
    //     country: "cz",
    //     store_name: "MATEX",
    //     store_address: "OC ALBERT, Chýnovská 3049, Tábor",
    //     owner_name: "Soňa Matyásková",
    //     owner_email: "",
    //     phone: "602187500",
    //     billing_address: "",
    //   },
    //   {
    //     city: "Znojmo",
    //     country: "cz",
    //     store_name: "NOVATEX",
    //     store_address: "",
    //     owner_name: "",
    //     owner_email: "",
    //     phone: "",
    //     billing_address: "Jesuitská 2, 669 02  Znojmo",
    //   },
    //   {
    //     city: "Třebíč",
    //     country: "cz",
    //     store_name: "IMPULS  móda",
    //     store_address: "Hasskova 14, 674 01 Třebíč",
    //     owner_name: "p. Zimová",
    //     owner_email: "zimova@impuls-moda.cz",
    //     phone: "725150616",
    //     billing_address: "Kaprova 14, 110 00  Praha",
    //   },
    //   {
    //     city: "Velká Bíteš",
    //     country: "cz",
    //     store_name: "STYL OP, s.r.o.",
    //     store_address: "Masarykovo náměstí 8, 595 01  Velká Bíteš",
    //     owner_name: "",
    //     owner_email: "li.rausova@gmail.com",
    //     phone: "566531001",
    //     billing_address: "Masarykovo náměstí 8, 595 01  Velká Bíteš",
    //   },
    //   {
    //     city: "Klatovy",
    //     country: "cz",
    //     store_name: "JOSS Fashion",
    //     store_address: "Kpt. Jaroše 94, 339 01  Klatovy",
    //     owner_name: "p. Čížek",
    //     owner_email: "joss.cizek@seznam.cz + joss.info@seznam.cz",
    //     phone: "734851383",
    //     billing_address: "",
    //   },
    //   {
    //     city: "Veľké Meziříčí",
    //     country: "cz",
    //     store_name: "",
    //     store_address: "",
    //     owner_name: "Dagmar Oliver",
    //     owner_email: "",
    //     phone: "731944430",
    //     billing_address: "U Statku 2140/26, 594 01 Veľké Meziříčí",
    //   },
    //   {
    //     city: "Jihlava",
    //     country: "cz",
    //     store_name: "N styl",
    //     store_address: "",
    //     owner_name: "Marie Nováková",
    //     owner_email: "",
    //     phone: "",
    //     billing_address: "Benešova 5, 586 01 Jihlava",
    //   },
    //   {
    //     city: "Strakonice",
    //     country: "cz",
    //     store_name: "STYL A ELEGANCE",
    //     store_address: "Bezděkovská 123, Strakonice",
    //     owner_name: "Zdeňka Chvostová",
    //     owner_email: "",
    //     phone: "724163949",
    //     billing_address: "",
    //   },
    //   {
    //     city: "Tábor",
    //     country: "cz",
    //     store_name: "Elegance ženy",
    //     store_address: "Nad Záhybem  182, 390 01  Tábor",
    //     owner_name: "Cihlářová Nadežda",
    //     owner_email: "cihlarova.n@seznam.cz",
    //     phone: "608981422",
    //     billing_address: "Palackého 351, 390 01  Tábor",
    //   },
    //   {
    //     city: "Vlašim",
    //     country: "cz",
    //     store_name: "no LIMIT Trading",
    //     store_address: "Masarykovo nám. 13, 393 01 Pelhřimov",
    //     owner_name: "Fousková",
    //     owner_email: "kfousek@seznam.cz",
    //     phone: "605273709",
    //     billing_address: "Vítezslava Hálka 203, 258 01  Vlašim",
    //   },
    //   {
    //     city: "Třeboň",
    //     country: "cz",
    //     store_name: "Boutique Trend Fashion",
    //     store_address: "Svobody 55, 379 01  Třeboň",
    //     owner_name: "Dvořáková Milena",
    //     owner_email: "dvorakova-milena@seznam.cz",
    //     phone: "777557061",
    //     billing_address: "Vodárenská 1096, 379 01 Třeboň",
    //   },
    //   {
    //     city: "České Budejovice",
    //     country: "cz",
    //     store_name: "",
    //     store_address: "",
    //     owner_name: "Šubrt Otakar",
    //     owner_email: "",
    //     phone: "",
    //     billing_address: "Veterná 20, 370 05 České  Budejovice",
    //   },
    //   {
    //     city: "Vodňany",
    //     country: "cz",
    //     store_name: "FASHION ",
    //     store_address: "ČSLA  215, 389 01  Vodňany",
    //     owner_name: "Smržová Jitka",
    //     owner_email: "smrzova@email.cz",
    //     phone: "604221185",
    //     billing_address: "ČSLA  215, 389 01  Vodňany",
    //   },
    //   {
    //     city: "Sušice",
    //     country: "cz",
    //     store_name: "DEKOLT",
    //     store_address: "T.G.Masaryka 20, 342 01 Sušice",
    //     owner_name: "Lašková Dana",
    //     owner_email: "dekolt.laskova@centrum.cz",
    //     phone: "604484990",
    //     billing_address: "Kaštanova 1160, 342 01  Sušice",
    //   },
    //   {
    //     city: "Uhlířske Janovice",
    //     country: "cz",
    //     store_name: "MODA NOVA",
    //     store_address: "Kolínska 185, 285 04 Uhl. Janovice",
    //     owner_name: "Rejhon Karel",
    //     owner_email: "karel.rejhon@post.cz",
    //     phone: "607533021",
    //     billing_address: "Kolínska 185, 285 04 Uhlířske Janovice",
    //   },
    //   {
    //     city: "Strakonice",
    //     country: "cz",
    //     store_name: "Společnosť Vojtovy",
    //     store_address: "",
    //     owner_name: "Stehlíková ?",
    //     owner_email: "",
    //     phone: "",
    //     billing_address: "Palackého nám. 91, 386 01  Strakonice",
    //   },
    //   {
    //     city: "Praha",
    //     country: "cz",
    //     store_name: "M-Benet",
    //     store_address: "OD KOTVA, 2. patro, Nám. republiky 656, Praha",
    //     owner_name: "Benedikt Petr",
    //     owner_email: "p.benedikt@centrum.cz",
    //     phone: "775213177",
    //     billing_address: "Chudenická 1133/36, 102 00 Praha",
    //   },
    //   {
    //     city: "Praha",
    //     country: "cz",
    //     store_name: "Elegance ",
    //     store_address: "Terronska 9, 160 00 Praha 6",
    //     owner_name: "Hejnová",
    //     owner_email: "hejnovazuzana@gmail.com",
    //     phone: "721109168",
    //     billing_address: "ANABA, Tyršova 411, 250 83 Škvorec",
    //   },
    //   {
    //     city: "",
    //     country: "cz",
    //     store_name: "MINI . MAXI",
    //     store_address: "160 00 Praha 6, ",
    //     owner_name: "Hejnová",
    //     owner_email: "",
    //     phone: "721109168",
    //     billing_address: "150 00  Praha, ",
    //   },
    //   {
    //     city: "Praha",
    //     country: "cz",
    //     store_name: "MEDLEY",
    //     store_address: "Vinohradská 68, 130 00 Praha 3",
    //     owner_name: "Kústková Dagmar",
    //     owner_email: "m.kustka@seznam.cz",
    //     phone: "777676861",
    //     billing_address: "Hrudičkova 2099/32, 148 00  Praha",
    //   },
    //   {
    //     city: "Praha",
    //     country: "cz",
    //     store_name: "VF MODA",
    //     store_address: "OC LUŽINY, Archeologická 2256/1, Praha",
    //     owner_name: "Antlová",
    //     owner_email: "vladka.antlova@vfmoda.cz",
    //     phone: "608113262",
    //     billing_address: "Archeologická 2256/1, 155 00 Praha 5",
    //   },
    //   {
    //     city: "Praha",
    //     country: "cz",
    //     store_name: "TIP",
    //     store_address: "",
    //     owner_name: "Menšík",
    //     owner_email: "",
    //     phone: "608938700",
    //     billing_address: "Roosveltová 49, 160 00  Praha",
    //   },
    //   {
    //     city: "Praha",
    //     country: "cz",
    //     store_name: "MODIS - Dámska móda",
    //     store_address: "Slezká 11, 110 00  Praha 2",
    //     owner_name: "Vetešníková Galina",
    //     owner_email: "vega99@centrum.cz",
    //     phone: "725679550",
    //     billing_address: "Slezká 11, 110 00  Praha 2",
    //   },
    //   {
    //     city: "Praha",
    //     country: "cz",
    //     store_name: "FLEUR",
    //     store_address: "Dukelská 1497, 271 01 Nové Strašecí",
    //     owner_name: "p. Hlásek",
    //     owner_email: "lukas.hl@centrum.cz",
    //     phone: "606332644",
    //     billing_address: "Šantrochova 1864/7, 162 00 Praha",
    //   },
    //   {
    //     city: "Kolín",
    //     country: "cz",
    //     store_name: "Atelier Nr. 48",
    //     store_address: "Husova 48, náměstí, 280 02 Kolín",
    //     owner_name: "Navarová Bohuna",
    //     owner_email: "b.pokorna@email.cz",
    //     phone: "602387900",
    //     billing_address: "Husova 48, náměstí, 280 02 Kolín",
    //   },
    //   {
    //     city: "Brandýs nad Labem",
    //     country: "cz",
    //     store_name: "",
    //     store_address: "Ivana Olbrachta 38, 250 01 Brandýs nad Labem",
    //     owner_name: "Burianová Jana",
    //     owner_email: "",
    //     phone: "773226532",
    //     billing_address: "28. řína 909, 277 11 Neratovice",
    //   },
    //   {
    //     city: "Brandýs nad Labem",
    //     country: "cz",
    //     store_name: "Obchod Versay",
    //     store_address: "Lipova 1498, 250 01 Brandýs nad Labem",
    //     owner_name: "Antončíková Libuše",
    //     owner_email: "liba.an@seznam.cz",
    //     phone: "723449698",
    //     billing_address: "Lipova 1498, 250 01 Brandýs nad Labem",
    //   },
    //   {
    //     city: "Veletrusy",
    //     country: "cz",
    //     store_name: "",
    //     store_address: "",
    //     owner_name: "Hlaváčková Jindra",
    //     owner_email: "",
    //     phone: "774032057",
    //     billing_address: "Alešova 291, 277 46  Veletrusy",
    //   },
    //   {
    //     city: "Mladá Boleslav",
    //     country: "cz",
    //     store_name: "Cyrany móda",
    //     store_address: "U Kasáren 1377, 293 01 Ml. Boleslav",
    //     owner_name: "Šuba Michal",
    //     owner_email: "jana.cy@seznam.cz",
    //     phone: "776635900",
    //     billing_address: "Erbenova 705/41, 293 01  Mladá Boleslav",
    //   },
    //   {
    //     city: "Svitavy",
    //     country: "cz",
    //     store_name: "Spodní prádlo",
    //     store_address: "T.G.Masaryka 4/5, 568 02 Svitavy - Město",
    //     owner_name: "Alena Čechalová",
    //     owner_email: "",
    //     phone: "602534770",
    //     billing_address: "",
    //   },
    //   {
    //     city: "Kladno",
    //     country: "cz",
    //     store_name: "412, s.r.o.",
    //     store_address: "",
    //     owner_name: "Slapničková",
    //     owner_email: "martina412@seznam.cz",
    //     phone: "602345725",
    //     billing_address: "Nová 200, 273 51  Velké Přítočno",
    //   },
    //   {
    //     city: "Plzeň",
    //     country: "cz",
    //     store_name: "KONTEX",
    //     store_address: "Chvalenická  22, 326 00  Plzeň",
    //     owner_name: "Kostecká Eva",
    //     owner_email: "ekostecka@seznam.cz",
    //     phone: "777666138",
    //     billing_address: "Chválenická 353/22, 326 00 Plzeň",
    //   },
    //   {
    //     city: "Plzeň",
    //     country: "cz",
    //     store_name: "SILUETTE",
    //     store_address: "Rooseveltova 8/5, 301 01 Plzeň",
    //     owner_name: "Světlíková Vendula",
    //     owner_email: "vensvetlikova@seznam.cz",
    //     phone: "775677051",
    //     billing_address: "Záhradní 329, 330 08 Zruč - Senec",
    //   },
    //   {
    //     city: "Tachov",
    //     country: "cz",
    //     store_name: "JOKO Móda",
    //     store_address: "",
    //     owner_name: "Uxová Šárka",
    //     owner_email: "",
    //     phone: "",
    //     billing_address: "Nám. republiky 9, 347 01  Tachov",
    //   },
    //   {
    //     city: "Mariánske Lázne",
    //     country: "cz",
    //     store_name: "",
    //     store_address: "",
    //     owner_name: "Šolehová Blanka",
    //     owner_email: "",
    //     phone: "",
    //     billing_address: "Rájov 114, 353 01 Mariánske Lázne",
    //   },
    //   {
    //     city: "Františkové Lázne",
    //     country: "cz",
    //     store_name: "LADY STUDIO",
    //     store_address: "",
    //     owner_name: "B.M.Markuzzi",
    //     owner_email: "",
    //     phone: "",
    //     billing_address: "Národní 13/11, 351 01 Františkové Lázne",
    //   },
    //   {
    //     city: "Česká Lípa",
    //     country: "cz",
    //     store_name: "Seneka móda",
    //     store_address: "Jindřicha z Lipé 125, 470 01  Česká Lípa",
    //     owner_name: "Dostálová",
    //     owner_email: "yvetkad@seznam.cz",
    //     phone: "487520820",
    //     billing_address: "Jindřicha z Lipé 125, 470 01 Česká Lípa",
    //   },
    //   {
    //     city: "Cheb",
    //     country: "cz",
    //     store_name: "MARCI",
    //     store_address: "",
    //     owner_name: "Obšivačová",
    //     owner_email: "marcicheb@seznam.cz",
    //     phone: "",
    //     billing_address: "17.listopadu  23, 350 01  Cheb",
    //   },
    //   {
    //     city: "Prúhonice",
    //     country: "cz",
    //     store_name: "DD SPORT - OD AZALKA",
    //     store_address: "",
    //     owner_name: "Dvorská",
    //     owner_email: "",
    //     phone: "",
    //     billing_address: "Říčanská 197, 252 43  Prúhonice",
    //   },
    //   {
    //     city: "Kadaň",
    //     country: "cz",
    //     store_name: "Boutique LUCIA",
    //     store_address: "kpl. Jaroše   519, 432 01  Kadaň",
    //     owner_name: "Paparegová Eva",
    //     owner_email: "paparegova.eva@seznam.cz",
    //     phone: "474342189",
    //     billing_address: "kpt. Jaroše 519, 432 01  Kadaň",
    //   },
    //   {
    //     city: "Žatec",
    //     country: "cz",
    //     store_name: "",
    //     store_address: "",
    //     owner_name: "Jáchymovská Kamila",
    //     owner_email: "j.kamila@centrum.cz",
    //     phone: "415710523",
    //     billing_address: "Dvořáková 18, 438 01  Žatec",
    //   },
    //   {
    //     city: "Ústí nad Labem",
    //     country: "cz",
    //     store_name: "TIMETEX",
    //     store_address: "Peškova 542 , 403 31 Ústí nad Labem",
    //     owner_name: "Vaňková Dana",
    //     owner_email: "damira@volny.cz",
    //     phone: "607032049",
    //     billing_address: "Peškova 542 , 403 31 Ústí nad Labem",
    //   },
    //   {
    //     city: "Děčín",
    //     country: "cz",
    //     store_name: "FANTAZIE",
    //     store_address: "Husovo nám. 117/4, 405 02  Děčín",
    //     owner_name: "Hájková Monika",
    //     owner_email: "butik@atlas.cz",
    //     phone: "723520834",
    //     billing_address: "Štursová 540/25, 405 02  Děčín",
    //   },
    //   {
    //     city: "Děčín",
    //     country: "cz",
    //     store_name: "",
    //     store_address: "",
    //     owner_name: "Ornet Jaroslav",
    //     owner_email: "",
    //     phone: "723342537",
    //     billing_address: "Vítězství   94, 405 02  Děčín",
    //   },
    //   {
    //     city: "Liberec",
    //     country: "cz",
    //     store_name: "ELISA",
    //     store_address: "5. května 41/34, 460 07  Liberec",
    //     owner_name: "Šibrava Roman",
    //     owner_email: "elisafashion@seznam.cz",
    //     phone: "730143035",
    //     billing_address: "1. máje 868/11, 460 07  Liberec",
    //   },
    //   {
    //     city: "Jablonec n/N.",
    //     country: "cz",
    //     store_name: "Prodejna GRÁCIE",
    //     store_address: "Podhorská 22, 466 01 Jablonec n/N.",
    //     owner_name: "p. Dudová",
    //     owner_email: "klara.free@centrum.cz",
    //     phone: "605257470",
    //     billing_address: "Ing. Svobodová, Pražská 76, 466 01  Jablones n/N.",
    //   },
    //   {
    //     city: "Česká Kamenice",
    //     country: "cz",
    //     store_name: "Textil u Plže",
    //     store_address: "Janáčková 204, 407 21 Česká Kamenice",
    //     owner_name: "Ženčuchová Lenka",
    //     owner_email: "lenkazencuchova@seznam.cz",
    //     phone: "606120100",
    //     billing_address: "Janáčková 204, 407 21 Česká Kamenice",
    //   },
    //   {
    //     city: "Jihlava",
    //     country: "cz",
    //     store_name: "HL MÓDA",
    //     store_address: "Masarykovo nám. 19, 586 01  Jihlava",
    //     owner_name: "Hekrlová",
    //     owner_email: "",
    //     phone: "733544959",
    //     billing_address: "Masarykovo nám. 19, 586 01  Jihlava",
    //   },
    //   {
    //     city: "Golčuv Jeníkov",
    //     country: "cz",
    //     store_name: "",
    //     store_address: "",
    //     owner_name: "Klimeš Zdeněk",
    //     owner_email: "klimes.jana@tiscali.cz",
    //     phone: "602126600",
    //     billing_address: "Jirásková 138, 582 82  Golčuv Jeníkov",
    //   },
    //   {
    //     city: "Hustopeče",
    //     country: "cz",
    //     store_name: "SAXALA fashion",
    //     store_address: "Husova 7, 693 01  Hustopeče",
    //     owner_name: "Kapková Zuzana",
    //     owner_email: "saxala.kapkova@seznam.cz",
    //     phone: "606367325",
    //     billing_address: "U vodojemu 1251/13, 693 01  Hustopeče",
    //   },
    //   {
    //     city: "Karlové Vary",
    //     country: "cz",
    //     store_name: "iris Boutique",
    //     store_address: "Dr. Davida Bechera 620/9, 360 01  Karlové Vary",
    //     owner_name: "Ilona Křížová",
    //     owner_email: "krizovailona@centrum.cz",
    //     phone: "774554525",
    //     billing_address: "Družební 1325/5, 363 01  Ostrov",
    //   },
    //   {
    //     city: "Moravská Třebová",
    //     country: "cz",
    //     store_name: "Oliver D & M",
    //     store_address: "Brnianska 6, 571 01  Moravská Třebová",
    //     owner_name: "Zdeněk Dvořák",
    //     owner_email: "",
    //     phone: "603490812",
    //     billing_address: "Hřebečská  1511/3, 571 01  Moravská Třebová",
    //   },
    //   {
    //     city: "Litomyšl",
    //     country: "cz",
    //     store_name: "Oliver D & M",
    //     store_address: "Smetanovo nám.92, 570 01 ",
    //     owner_name: "Zdeněk Dvořák",
    //     owner_email: "",
    //     phone: "603490812",
    //     billing_address: "Hřebečská  1511/3, 571 01  Moravská Třebová",
    //   },
    //   {
    //     city: "Brno",
    //     country: "cz",
    //     store_name: "IBC móda sport",
    //     store_address: "Příkop 6, 602 00 Brno",
    //     owner_name: "p. Kašparková",
    //     owner_email: "ibcsport@seznam.cz",
    //     phone: "739302788",
    //     billing_address: "Karel Kroupa, Dubova 641/13, 637 00  Brno",
    //   },
    //   {
    //     city: "Strakonice",
    //     country: "cz",
    //     store_name: "STYL & ELEGANCE",
    //     store_address: "",
    //     owner_name: "p. Chvostová Zdeňka",
    //     owner_email: "zdenkachvostova@seznam.cz",
    //     phone: "",
    //     billing_address: "Skály  1, 386 01  Skály",
    //   },
    //   {
    //     city: "Ústí nad Labem",
    //     country: "cz",
    //     store_name: "",
    //     store_address: "Masarykova 635/159, ",
    //     owner_name: "Dana Vaňková",
    //     owner_email: "damiva@volny.cz",
    //     phone: "",
    //     billing_address: "",
    //   },
    //   {
    //     city: "Veľká Bíteš",
    //     country: "cz",
    //     store_name: "For You Style",
    //     store_address: "Masarykovo nám. 8, ",
    //     owner_name: "Myroslava Prokeshová",
    //     owner_email: "prokeshova@seznam.cz",
    //     phone: "775679735",
    //     billing_address: "Kostelní 73, 595 01  Veľká Bíteš",
    //   },
    //   {
    //     city: "Tábor",
    //     country: "cz",
    //     store_name: "MATEX",
    //     store_address: "OC ALBERT, Chýnovská 3049, Tábor",
    //     owner_name: "Soňa Matyásková",
    //     owner_email: "usoni@seznam.cz",
    //     phone: "602187500",
    //     billing_address: "",
    //   },
    //   {
    //     city: "Klatovy",
    //     country: "cz",
    //     store_name: "",
    //     store_address: "",
    //     owner_name: "Jana Špačková",
    //     owner_email: "",
    //     phone: "776207525",
    //     billing_address: "neberie, ",
    //   },
    //   {
    //     city: "Telč, Trešť",
    //     country: "cz",
    //     store_name: "",
    //     store_address: "",
    //     owner_name: "p. Bakajová",
    //     owner_email: "",
    //     phone: "606630378",
    //     billing_address: "neberie, ",
    //   },
    //   {
    //     city: "Praha",
    //     country: "cz",
    //     store_name: "New Fashion",
    //     store_address: "Sokolovská 38, Praha 8",
    //     owner_name: "Petra Nováková",
    //     owner_email: "petra.novakova@outlook.cz",
    //     phone: "602211923",
    //     billing_address: "Evropská 676, 160 00 Praha 6",
    //   },
    //   {
    //     city: "Praha",
    //     country: "cz",
    //     store_name: "VOLANSKI Group, s.r.o.",
    //     store_address: "Kolínská 1686/13, 130 00 Praha 3",
    //     owner_name: "vedúca p. Rusová",
    //     owner_email: "info@volansky.cz",
    //     phone: "608108983",
    //     billing_address: "",
    //   },
    //   {
    //     city: "Beroun",
    //     country: "cz",
    //     store_name: "",
    //     store_address: "",
    //     owner_name: "Aleš Procházka",
    //     owner_email: "",
    //     phone: "736768283",
    //     billing_address: "Hornohradební 162, 266 01 Beroun",
    //   },
    //   {
    //     city: "Turnov",
    //     country: "cz",
    //     store_name: "Midas - Modes",
    //     store_address: "ul. Jirásková 133, 511 01  Turnov",
    //     owner_name: "Daniela Sixtová",
    //     owner_email: "",
    //     phone: "603872979",
    //     billing_address: "",
    //   },
    //   {
    //     city: "Plzeň",
    //     country: "cz",
    //     store_name: "EXTRAVAGANZA fashion",
    //     store_address: "Náměstí republiky 28, Pasáž Slávie, Plzeň",
    //     owner_name: "Kristína Janečková",
    //     owner_email: "info@extravaganza-fashion.cz",
    //     phone: "722672762",
    //     billing_address: "Lužní 6, Radobyčice, 301 00  Plzeň",
    //   },
    //   {
    //     city: "Trnava",
    //     country: "sk",
    //     store_name: "Dám. zn. Móda JARKA",
    //     store_address: "Paulínska 12, 674 01  Trnava",
    //     owner_name: "Jaroslava Hojerová",
    //     owner_email: "",
    //     phone: "903776226, 902895033",
    //     billing_address: "M.R.Štefánika 3080/14, 926 01  Sereď",
    //   },
    //   {
    //     city: "Komárno",
    //     country: "sk",
    //     store_name: "STREET MÓDA PLUS",
    //     store_address: "Palatínova 9, 945 01  Komárno",
    //     owner_name: "Henrieta Kellerová",
    //     owner_email: "",
    //     phone: "356400083",
    //     billing_address: "Vodná 25/7, 945 01  Komárno",
    //   },
    //   {
    //     city: "Topoľčany",
    //     country: "sk",
    //     store_name: "UNIEL",
    //     store_address: "OC Jednota, Stumerová 324/5, 955 01  Topoľčany",
    //     owner_name: "Miroslav Kostolný",
    //     owner_email: "",
    //     phone: "905416499",
    //     billing_address: "Zemianska 422, 956 21  Jacovce",
    //   },
    //   {
    //     city: "Partizánske",
    //     country: "sk",
    //     store_name: "ODEVY",
    //     store_address: "Moyzesova 1, 958 03 Partizánske",
    //     owner_name: "Ingrid Nguyen",
    //     owner_email: "ingrid.nguyenova@gmail.com",
    //     phone: "905835882",
    //     billing_address: "Hai Nguyen Duc SLO-VIMEX, Stredná 1647/13,  Partizánske",
    //   },
    //   {
    //     city: "Prievidza",
    //     country: "sk",
    //     store_name: "Odevy Sofia",
    //     store_address: "Nábrežná ul. 24, 971 01 Prievidza",
    //     owner_name: "Silvia Pompová",
    //     owner_email: "spompova@gmail.com",
    //     phone: "944663158",
    //     billing_address: "SIMIZ, B.Bjornsona 2/4, 971 01  Prievidza",
    //   },
    //   {
    //     city: "Považská Bystrica",
    //     country: "sk",
    //     store_name: "VARIANT móda",
    //     store_address: "Centrum 3, 017  07 Pov.Bystrica",
    //     owner_name: "Viera Rojková",
    //     owner_email: "v.turanova@gmail.com",
    //     phone: "042/444 1380, 905708103",
    //     billing_address: "Hliny 1284/107, 017 07  Pov. Bystrica",
    //   },
    //   {
    //     city: "Žilina",
    //     country: "sk",
    //     store_name: "BENO",
    //     store_address: "OC DUBEŇ, Vysokoškoláka 52 010 01  Žilina",
    //     owner_name: "p. Vlčková",
    //     owner_email: "",
    //     phone: "902895553",
    //     billing_address: "Dolné  Rudiny 1, 010 01  Žilina",
    //   },
    //   {
    //     city: "Martin",
    //     country: "sk",
    //     store_name: "STREET MÓDA, OC Galéria",
    //     store_address: "Námestie SNP 4665/2, 036 01  Martin",
    //     owner_name: "p. Dadajová",
    //     owner_email: "streetkosice@gmail.com",
    //     phone: "905470275",
    //     billing_address: "DADYLER,s.r.o., Hlavná 117, 040 01  Košice",
    //   },
    //   {
    //     city: "Dolný Kubín",
    //     country: "sk",
    //     store_name: "MÓDA STREET PLUS",
    //     store_address: "VÚB Banka, Radlinského 34, 026 01 Dolný Kubín",
    //     owner_name: "Edita Kotvasová",
    //     owner_email: "",
    //     phone: "907101753",
    //     billing_address: "estreet, Matúšková 1639/12, 026 01 Dolný Kubín",
    //   },
    //   {
    //     city: "Námestovo",
    //     country: "sk",
    //     store_name: "JEANS MÓDA, REBECA",
    //     store_address: "OC Klinec, Hviezdoslavovo, nám. 213,  029 01 Námestovo",
    //     owner_name: "p. Chudiaková",
    //     owner_email: "",
    //     phone: "903378752",
    //     billing_address: "Lazova 380, 029 43 Zubrohlava",
    //   },
    //   {
    //     city: "Liptovský Mikuláš",
    //     country: "sk",
    //     store_name: "MINI S",
    //     store_address: "OC Jasná, Garbiarska 695, 031 01 Liptovský Mikuláš",
    //     owner_name: "Katarína Spilá",
    //     owner_email: "",
    //     phone: "911106640",
    //     billing_address: "Podtatranského 1044/4, 031 01  Liptovský Mikuláš",
    //   },
    //   {
    //     city: "Spišská Nová Ves",
    //     country: "sk",
    //     store_name: "ELEGANCIA",
    //     store_address: "Letná 79/72, 052 01   S.N.V.",
    //     owner_name: "p. Kováčová",
    //     owner_email: "elegancia@gmail.com",
    //     phone: "053/442 3302, 911931866",
    //     billing_address: "Letná 72, 052 01 Spišská Nová Ves",
    //   },
    //   {
    //     city: "Prešov",
    //     country: "sk",
    //     store_name: "MINIMARKET",
    //     store_address: "Hlavná ul. 125, 080 01  Prešov",
    //     owner_name: "p. Kalátová",
    //     owner_email: "minimarket@post.sk",
    //     phone: "051/773 3007, 907056888",
    //     billing_address: "Záhradná 77/21, 082 16 Záhradné",
    //   },
    //   {
    //     city: "Snina",
    //     country: "sk",
    //     store_name: "M-ARTS",
    //     store_address: "Strojárenská 1, 069 01  Snina",
    //     owner_name: "Marta Podoláková",
    //     owner_email: "m-arts@centrum.sk",
    //     phone: "577750547",
    //     billing_address: "Jesenského 2843/191, 069 01  Snina",
    //   },
    //   {
    //     city: "Humenné",
    //     country: "sk",
    //     store_name: "M-ARTS",
    //     store_address: "Nám. Slobody 23, 066 01  Humenné",
    //     owner_name: "Marta Podoláková",
    //     owner_email: "",
    //     phone: "574432356",
    //     billing_address: "Jesenského 2843/191, 069 01  Snina",
    //   },
    //   {
    //     city: "Vranov n/Topľou",
    //     country: "sk",
    //     store_name: "M-ARTS",
    //     store_address: "Štefánika 136, 093 01 Vranov n/Topľou",
    //     owner_name: "Marta Podováková",
    //     owner_email: "",
    //     phone: "577750541",
    //     billing_address: "Jesenského 2843/191, 069 01  Snina",
    //   },
    //   {
    //     city: "Trebišov",
    //     country: "sk",
    //     store_name: "Móda STREET - LUXUS",
    //     store_address: "M.R.Štefánika 54/6, 075 01 Trebišov",
    //     owner_name: "Ľubomíra Suchá",
    //     owner_email: "obuvluxus@gmail.com",
    //     phone: "918506692",
    //     billing_address: "Škultétyho 2077/11, 075 01  Trebišov",
    //   },
    //   {
    //     city: "Košice",
    //     country: "sk",
    //     store_name: "Móda STREET",
    //     store_address: "Hlavná ul. 117, 040 01  Košice",
    //     owner_name: "p. Dadajová",
    //     owner_email: "streetkosice@gmail.com",
    //     phone: "905470275",
    //     billing_address: "MODA PLUS, s.r.o.,Hlavná 117, 040 01  Košice",
    //   },
    //   {
    //     city: "Turňa nad Bobvou",
    //     country: "sk",
    //     store_name: "T.O.T.",
    //     store_address: "Hlavná ulica 1, 044 02 Turňa nad Bodvou",
    //     owner_name: "Priška Derjánová",
    //     owner_email: "",
    //     phone: "905452024",
    //     billing_address: "Moldavská cesta 426/37, 044 02 Turňa nad Bodvou",
    //   },
    //   {
    //     city: "Rožňava",
    //     country: "sk",
    //     store_name: "Salón ANGEL",
    //     store_address: "Košická 7, 048 01 Rožňava",
    //     owner_name: "p. Hrivnáková",
    //     owner_email: "",
    //     phone: "918661706",
    //     billing_address: "Zakarpatská 1812/22, 048 01 Rožňava",
    //   },
    //   {
    //     city: "Lučenec",
    //     country: "sk",
    //     store_name: "GLANTZ",
    //     store_address: "T.G.Masaryka 351/11, 984 01 Lučenec",
    //     owner_name: "Eleo.Koroncziová",
    //     owner_email: "",
    //     phone: "474330595",
    //     billing_address: "A.Bernoláka 2705/1, 984 01 Lučenec",
    //   },
    //   {
    //     city: "Zvolen",
    //     country: "sk",
    //     store_name: "Butik OLIVIA",
    //     store_address: "A.Sládkoviča 90/5, 960 01 Zvolen",
    //     owner_name: "Simona Plavúchová",
    //     owner_email: "olivia.zvolen@gmail.com",
    //     phone: "905313324",
    //     billing_address: "Rybárska 292/9, 962 31 Sliač",
    //   },
    //   {
    //     city: "Bánska Bystrica",
    //     country: "sk",
    //     store_name: "MB FASHION",
    //     store_address: "Dolná 22, 974 01 Bánska Bystrica",
    //     owner_name: "p. Blažková",
    //     owner_email: "blazkova@mbfashion.sk",
    //     phone: "907818444",
    //     billing_address: "M.Benku 4, 969 01 Bánská Štiavnica",
    //   },
    //   {
    //     city: "Žiar nad Hronom",
    //     country: "sk",
    //     store_name: "MB FASHION",
    //     store_address: "Š. Moyzesa 424, 965 01 Žiar nad Hronom",
    //     owner_name: "p. Blažková",
    //     owner_email: "",
    //     phone: "907818444",
    //     billing_address: "M.Benku 4, 969 01 Bánská Štiavnica",
    //   },
    //   {
    //     city: "Brezno",
    //     country: "sk",
    //     store_name: "Predajňa odevov  OZEBA",
    //     store_address: "Českosl. Armády 65/17, 977 01  Brezno",
    //     owner_name: "p. Bábeľová",
    //     owner_email: "",
    //     phone: "",
    //     billing_address: "",
    //   },
    //   {
    //     city: "Trnava",
    //     country: "sk",
    //     store_name: "JOSS Fashion, s.r.o.",
    //     store_address: "Kollárová 20, 917 01  Trnava",
    //     owner_name: "p. Kosáková",
    //     owner_email: "viera44@azet.sk",
    //     phone: "908434012",
    //     billing_address: "Kollárová 20, 917 01  Trnava",
    //   },
    //   {
    //     city: "Bojnice",
    //     country: "sk",
    //     store_name: "RST - ODEVY",
    //     store_address: "Školská 384/72, 972 01  Bojnice",
    //     owner_name: "p. Slošiarová",
    //     owner_email: "",
    //     phone: "905542185",
    //     billing_address: "",
    //   },
    //   {
    //     city: "Holíč",
    //     country: "sk",
    //     store_name: "Boutique MIX",
    //     store_address: "Hollého 119, 908 51 Holíč",
    //     owner_name: "p. Machlica Pavel",
    //     owner_email: "pmachlica@hotmail.com",
    //     phone: "034/668 3282",
    //     billing_address: "Hollého 119, 908 51  Holíč",
    //   },
    //   {
    //     city: "Trebišov",
    //     country: "sk",
    //     store_name: "LITEX",
    //     store_address: "M.R.Štefánika 54, 075 01  Trebišov",
    //     owner_name: "p. Vančová",
    //     owner_email: "vancova.hena@gmail.com",
    //     phone: "915879588",
    //     billing_address: "M.R.Štefánika 54, 075 01  Trebišov",
    //   },
    //   {
    //     city: "Třinec",
    //     country: "mr",
    //     store_name: "Květinářství Móda",
    //     store_address: "Nábřežní 1059, 739 61  Třinec",
    //     owner_name: "Bc. Machková Marcela",
    //     owner_email: "info@kvetinarstvitrinec.cz",
    //     phone: "776002517, 608875317",
    //     billing_address: "Poštovní ulice 604, 739 61 Třinec",
    //   },
    //   {
    //     city: "Nový Jičín",
    //     country: "mr",
    //     store_name: "J.M.  MODA",
    //     store_address: "Sokolovská 600/29, 741 01  Nový Jičín",
    //     owner_name: "Šturalová",
    //     owner_email: "sturalova.tina@seznam.cz",
    //     phone: "733531331",
    //     billing_address: "Masná 1324/1, 702 00  Ostrava",
    //   },
    //   {
    //     city: "Šumperk",
    //     country: "mr",
    //     store_name: "ODĚVY",
    //     store_address: "Hlavní třída 2, 787 01  Šumperk",
    //     owner_name: "Kolářová Božena",
    //     owner_email: "kolarovasu@seznam.cz",
    //     phone: "739323230",
    //     billing_address: "nám. Jana Zajíce 2958/14, 787 01  Šumperk",
    //   },
    //   {
    //     city: "Vsetín",
    //     country: "mr",
    //     store_name: "FASHION - H",
    //     store_address: "Na Příkopě 814/22, 755 01  Vsetín",
    //     owner_name: "Fabianová Anna",
    //     owner_email: "fashionvsetin@seznam.cz",
    //     phone: "731106790",
    //     billing_address: "Na Příkopě 814/22, 755 01  Vsetín",
    //   },
    //   {
    //     city: "Břeclav",
    //     country: "mr",
    //     store_name: "AMAZONKA",
    //     store_address: "Fintajslova 51, 690 02  Břeclav",
    //     owner_name: "Kaňa Vlastimil",
    //     owner_email: "kanova@setes.cz",
    //     phone: "603258343",
    //     billing_address: "Okružní 1018, 691 42 Valtice",
    //   },
    //   {
    //     city: "Luhačovice",
    //     country: "mr",
    //     store_name: "KATE  Fashion",
    //     store_address: "Dr. Veselského  1066, 763 26 Luhačovice",
    //     owner_name: "Dvořáková Kateřina",
    //     owner_email: "katefashion@seznam.cz",
    //     phone: "775257224",
    //     billing_address: "Družstevní 93, 763 26 Luhačovice",
    //   },
    //   {
    //     city: "Uherské Hradište",
    //     country: "mr",
    //     store_name: "MARRGO",
    //     store_address: "Zelený trh 1249, 686 01 Uherské Hradište",
    //     owner_name: "Zlámalová Margita",
    //     owner_email: "zlamalova.margita@seznam.cz",
    //     phone: "732605515",
    //     billing_address: "Zelený trh 1249, 686 01 Uherské Hradište",
    //   },
    //   {
    //     city: "Uherský Brod",
    //     country: "mr",
    //     store_name: "Butik Lenka Prachřová",
    //     store_address: "Komenského 206, 688 01 Uherský Brod",
    //     owner_name: "Prachařová Lenka",
    //     owner_email: "info@lpracharova.cz",
    //     phone: "776678091",
    //     billing_address: "Šumice 342, 687 31 Šumice",
    //   },
    //   {
    //     city: "Zlín",
    //     country: "mr",
    //     store_name: "Butik Lenka Prachřová",
    //     store_address: "Záramí 72, 760 01  Zlín",
    //     owner_name: "Prachařová Lenka",
    //     owner_email: "info@lpracharova.cz",
    //     phone: "776678091",
    //     billing_address: "Šumice 342, 687 31 Šumice",
    //   },
    //   {
    //     city: "Prostějov",
    //     country: "mr",
    //     store_name: "SONÁTA",
    //     store_address: "Žeranovská 8, 796 01 Prostějov",
    //     owner_name: "Volek",
    //     owner_email: "rv@rvfashion.cz",
    //     phone: "773592104",
    //     billing_address: "RV Fashion Style, Žeranovská 989/8, Prostějov",
    //   },
    //   {
    //     city: "Prostějov",
    //     country: "mr",
    //     store_name: "SONÁTA",
    //     store_address: "Plumlovská 28, 796 01  Prostějov",
    //     owner_name: "Volek",
    //     owner_email: "",
    //     phone: "773592104",
    //     billing_address: "RV Fashion Style, Žeranovská 989/8, Prostějov",
    //   },
    //   {
    //     city: "Olomouc",
    //     country: "mr",
    //     store_name: "SONÁTA",
    //     store_address: "OC Šantovka, 779 00 Olomouc",
    //     owner_name: "Volek",
    //     owner_email: "",
    //     phone: "773592104",
    //     billing_address: "RV Fashion Style, Žeranovská 989/8, Prostějov",
    //   },
    //   {
    //     city: "Hodonín",
    //     country: "mr",
    //     store_name: "JD Woman",
    //     store_address: "Štefánikova 9, 695 01 Hodonín",
    //     owner_name: "Výletová Jana",
    //     owner_email: "jankavyletova@gmail.com",
    //     phone: "602422585",
    //     billing_address: "Vítezná 453, 695 01  Hodonín",
    //   },
    //   {
    //     city: "Valašské Klobúky",
    //     country: "mr",
    //     store_name: "Odevy MODENA",
    //     store_address: "Masarykovo nám. 107",
    //     owner_name: "Mrázová Věra",
    //     owner_email: "",
    //     phone: "736450013",
    //     billing_address: "Záhumení 730, 766 01 Valašské Klobúky",
    //   },
    //   {
    //     city: "Hranice",
    //     country: "mr",
    //     store_name: "Textil - prádlo",
    //     store_address: "Jirásková 12, 753 01  Hranice",
    //     owner_name: "Věra Šváčková",
    //     owner_email: "svackovavera@seznam.cz",
    //     phone: "604832995",
    //     billing_address: "Sklený kopec 1750, 753 01  Hranice",
    //   },
    //   {
    //     city: "Kroměříž",
    //     country: "mr",
    //     store_name: "MISSIS FASHION",
    //     store_address: "1. mája 283/15, 767 01  Kroměříž",
    //     owner_name: "p. Zapletalová",
    //     owner_email: "",
    //     phone: "777551911",
    //     billing_address: "",
    //   },
    //   {
    //     city: "Val. Meziříčí",
    //     country: "mr",
    //     store_name: "GAFRI 13, s.r.o.",
    //     store_address: "Náměstí 74, 757 01  Valašské Meziříčí",
    //     owner_name: "Gabriela Blažková",
    //     owner_email: "eshop@mlfashion.cz",
    //     phone: "603451198",
    //     billing_address: "K Pasekám 2984, 760 01  Zlín",
    //   },
    //   {
    //     city: "Kyjov",
    //     country: "mr",
    //     store_name: "LINIE",
    //     store_address: "Svatoborská 496, 697 01  Kyjov",
    //     owner_name: "Libuše Kobzová",
    //     owner_email: "",
    //     phone: "603171007, 776870560",
    //     billing_address: "Boršovská 3222/66, 697 01  Kyjov",
    //   },
    //   {
    //     city: "Hranice",
    //     country: "mr",
    //     store_name: "AVENA TRADE,s.r.o.",
    //     store_address: "Radniční 29, 753 01  Hranice",
    //     owner_name: "Hana Šváčková",
    //     owner_email: "svackova@lapetite.cz",
    //     phone: "606455236",
    //     billing_address: "",
    //   },
    //   {
    //     city: "Opava",
    //     country: "mr",
    //     store_name: "ELEGANT",
    //     store_address: "Olomoucká 15, 746 01  Opava",
    //     owner_name: "Mgr. J.Víchová",
    //     owner_email: "eleg-op@seznam.cz",
    //     phone: "605918551",
    //     billing_address: "",
    //   },
    //   {
    //     city: "Uherské Hradište",
    //     country: "mr",
    //     store_name: "",
    //     store_address: "",
    //     owner_name: "M. Daňková",
    //     owner_email: "",
    //     phone: "723423900",
    //     billing_address: "J. Lucemburského 232, 686 01 Uh. Hradište",
    //   },
    // ];
    // END OF MASS DATA ARRAY

    // function massUpload() {
    //   batch.forEach(async (element) => {
    //     await createDistributor({ ...element });
    //   });
    // }

    return { form, onSubmit };
  },
};
</script>
